module.exports = __webpack_public_path__ + "img/Nachrichten.a6fee3df.svg";